import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
    {
        // 登录
        path: "/login",
        name: "Login",
        component: resolve => require(["@/views/login/Login"], resolve)
    },
    {
      // 找回密码
      path: '/retrievePwd',
      name: 'retrievePwd',
      component: resolve => require(["@/views/login/RetrievePwd"], resolve)
    },
    {
        path: "/",
        redirect: '/home'
    },
    {
        path: "/home",
        component: resolve => require(["@/views/base/home/Home"], resolve),
        // 子路由
        children: [{
            // 系统首页
            path: "/",
            name: "systemHomePage",
            component: resolve => require(["@/views/systemHomePage/SystemHomePage"], resolve)
        },
        {
            // 推广计划管理
            path: "/campaign",
            name: "campaign",
            component: resolve => require(["@/views/campaign/campaign"], resolve)
        },
        {
            // 推广计划管理=> 套餐管理
            path: "/campaign/package",
            name: "Package",
            component: resolve => require(["@/views/campaign/Package/index"], resolve),
            redirect:to => {
                return '/campaign/package/packageList'
            },
            children:[{
                path:"orderList",
                name:"orderList",
                component: resolve => require(["@/views/campaign/Package/orderList"], resolve),
            },{
                path:"packageList",
                name:"packageList",
                component: resolve => require(["@/views/campaign/Package/packageList"], resolve),
            }]
        },
        {
            // 推广计划管理=> 套餐管理=>上传素材
            path: "/campaign/uploadMat",
            name: "UploadMat",
            component: resolve => require(["@/views/campaign/uploadMat"], resolve)
        },
        {
            // 新增/編輯推广计划
            path: "/campaign/operateCampaign",
            name: "operateCampaign",
            component: resolve => require(["@/views/campaign/operateCampaign"], resolve)
        },
        {
            //推广组管理
            path: "/adgroup",
            name: "adgroup",
            component: resolve => require(["@/views/campaign/adgroup"], resolve)
        },
        {
            //新增/編輯推广组管理
            path: "/operateAdgroup",
            name: "operateAdgroup",
            component: resolve => require(["@/views/campaign/operateAdgroup"], resolve)
        },
        {
            //广告管理
            path: "/adinfo",
            name: "adinfo",
            component: resolve => require(["@/views/campaign/adinfo"], resolve)
        },
        {
            //新增/編輯广告管理
            path: "/operateAdinfo",
            name: "operateAdinfo",
            component: resolve => require(["@/views/campaign/operateAdinfo"], resolve)
        },
        {
            //用户群管理
            path: "/customer",
            name: "customer",
            component: resolve => require(["@/views/customer/customer"], resolve)
        },
        {
            //新增/編輯用户群管理
            path: "/customer/operateCustomer",
            name: "operateCustomer",
            component: resolve => require(["@/views/customer/operateCustomer"], resolve)
        },
        {
            //查看数据包
            path: "/customer/dataPackage",
            name: "dataPackage",
            component: resolve => require(["@/views/customer/dataPackage"], resolve)
        },
        {
            // 账户中心
            path: "/account_center",
            name: "AccountInfo",
            component: resolve => require(["@/views/accountCenter/AccountInfo"], resolve)

        },
        {
            // 修改密码
            path: "/account_center/updatePassword",
            name: "updatePassword",
            component: resolve => require(["@/views/accountCenter/updatePassword"], resolve)
        },
        {
            // 报表统计
            path: "/report",
            name: "report",
            component: resolve => require(["@/views/report/report"], resolve)
        },
        {
            // 查看报表
            path: "/viewReport/:name/:id/:campaignId",
            name: "viewReport",
            component: resolve => require(["@/views/report/viewReport/viewReport"], resolve),
            redirect:to => {
                return '/viewReport/:name/:id/:campaignId/day'
            },
            children:[{
                path:"day",
                name:"day",
                component: resolve => require(["@/views/report/viewReport/day"], resolve),
            },{
                path:"hour",
                name:"hour",
                component: resolve => require(["@/views/report/viewReport/hour"], resolve),
            }]
        },
        {
            // 用户操作日志
            path: "/userLog",
            name: "userLog",
            component: resolve => require(["@/views/accountCenter/userLog"], resolve)
        },
        {
          // 定向包管理
          path: "/dmp/:id",
          name: "dmpList",
          component: resolve => require(["@/views/dmp/index"], resolve)
        },
        // {
        //   // 方案包管理
        //   path: "/projectList",
        //   name: "projectList",
        //   component: resolve => require(["@/views/dmp/index"], resolve)
        // }
    ]
	},
	{ path: '*', redirect: '/404', }
];

export default new Router({
    routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js